var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"320px"}},[_c('LogTable',{attrs:{"entityId":'632',"entityType":6,"type":4}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }